(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', './GroupTitle', './GroupList', 'prop-types'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('./GroupTitle'), require('./GroupList'), require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.GroupTitle, global.GroupList, global.propTypes);
    global.LinkGroup = mod.exports;
  }
})(this, function (exports, _react, _GroupTitle, _GroupList, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _GroupTitle2 = _interopRequireDefault(_GroupTitle);

  var _GroupList2 = _interopRequireDefault(_GroupList);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var LinkGroup = function (_React$Component) {
    _inherits(LinkGroup, _React$Component);

    function LinkGroup(props) {
      _classCallCheck(this, LinkGroup);

      var _this = _possibleConstructorReturn(this, (LinkGroup.__proto__ || Object.getPrototypeOf(LinkGroup)).call(this, props));

      _this.state = {
        styles: {
          height: '75px',
          overflow: 'hidden',
          padding: '0',
          float: 'left',
          border: 'none'
        },
        listOpen: false,
        id: _this.props.group.title.text.toLowerCase().replace(/\s+/, '')
      };
      return _this;
    }

    _createClass(LinkGroup, [{
      key: 'handleListEnter',
      value: function handleListEnter() {
        this.setState({
          styles: {
            height: 'auto',
            overflow: 'visible',
            color: '#fff',
            padding: '0',
            float: 'left'
          },
          isEntered: true
        });
      }
    }, {
      key: 'handleListLeave',
      value: function handleListLeave() {
        this.setState({
          styles: {
            height: '75px',
            overflow: 'hidden',
            padding: '0',
            float: 'left'
          },
          isEntered: false
        });
      }
    }, {
      key: 'toggleOpen',
      value: function toggleOpen() {
        this.props.handleLinkGroups(this.state.id);
      }
    }, {
      key: 'render',
      value: function render() {
        var listOpen = false;

        // const listOpen = this.props.groupLinks[this.state.id] ? this.props.groupLinks[this.state.id].isOpen : false;
        // Removes uncessary undefined group links and empty objects. Since this is set on render
        // there are quite a few of them
        if (Object.keys(this.props.groupLinks).length > 0 && this.props.groupLinks[this.state.id]) {
          listOpen = this.props.groupLinks[this.state.id].isOpen;
        }

        return _react2.default.createElement(
          'li',
          {
            className: 'header-link-group',
            onMouseEnter: this.handleListEnter.bind(this),
            onMouseLeave: this.handleListLeave.bind(this),
            style: !this.props.isMobile ? this.state.styles : null
          },
          _react2.default.createElement(
            'div',
            {
              style: {
                padding: '0',
                position: 'relative',
                cursor: 'pointer'
              }
            },
            _react2.default.createElement(_GroupTitle2.default, {
              title: this.props.group.title.text,
              href: this.props.group.title.src,
              className: this.props.group.title.className,
              listOpen: listOpen,
              isOpen: this.state.isOpen,
              isMobile: this.props.isMobile,
              toggleOpen: this.toggleOpen.bind(this)
            }),
            this.state.isEntered && !this.props.isMobile ? _react2.default.createElement('div', { className: 'menu-item-border', style: {
                marginTop: '-5px',
                borderBottom: '5px solid #f0ab00',
                width: '100%',
                cursor: 'pointer'
              } }) : _react2.default.createElement('div', { className: 'menu-item-border' }),
            _react2.default.createElement(_GroupList2.default, {
              list: this.props.group.list,
              listOpen: listOpen,
              isMobile: this.props.isMobile
            })
          )
        );
      }
    }]);

    return LinkGroup;
  }(_react2.default.Component);

  exports.default = LinkGroup;


  LinkGroup.propTypes = {
    group: _propTypes2.default.object,
    count: _propTypes2.default.number,
    isMobile: _propTypes2.default.bool,
    groupLinks: _propTypes2.default.object,
    handleLinkGroups: _propTypes2.default.func
  };
});